// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"9970cf22","312":"757a952c","421":"b6c543c3","493":"670e240f","578":"9970cf22","637":"9c2907eb","678":"ae4bab1e","787":"131e6ce7","805":"9970cf22","895":"3776b637"}[chunkId] + ".chunk.css";
};